import React, { useEffect } from 'react'
import className from 'classnames/bind'

import style from './MyhouseReviewModifyPage.module.scss'

import BlindContent from '@Components/VAC/common/BlindContent'
import MyhouseHeader from '@Components/atoms/MyhouseHeader'
import MyhouseReviewModifyMain from '@Components/modules/MyhouseReviewModifyMain'
import { MY_HOUSE_BOARD_TYPE, MY_HOUSE_BOARD_WRITING_TYPE } from '@Root/contants/myhouse'

const cx = className.bind(style)

const MyhouseReviewModifyPage: React.FC = () => {
  return (
    <>
      <MyhouseHeader title="입주민 리뷰 수정" boardType={MY_HOUSE_BOARD_TYPE.REVIEW} writingType={MY_HOUSE_BOARD_WRITING_TYPE.MODIFY} />
      <section id="content" className={cx('content_myhouse', 'type_enrol')} role="main">
        <BlindContent />
        <div className={cx('content_enrol_inner')}>
          <MyhouseReviewModifyMain />
        </div>
      </section>
    </>
  )
}

export default MyhouseReviewModifyPage
